import { useEffect, useMemo, useState } from "react";
import { Alert, Input } from "antd";
import dayjsTZ from "../../../../utils/dayjs";
import ClockOutModal from "./clockOutModal/ClockOutModal";
import { HollowDotsSpinner } from "react-epic-spinners";
import { ConfirmIcon } from "../../../../assets/icons";
import Clock from "../../../../utils/LiveClock";
import { eventTracker } from "../../../../utils/eventTracker";
import { showErrorMsg } from "../../../Documentation/utils/Messages";
import { overnightBannerCopy } from "./overnightClose";
import { useAuth } from "../../../../authentication/authHelpers";
import { useSelector } from "react-redux";
import { resolveClockingTimezone } from "../../../../utils/timezone/teamTimezone";
import { getLastOnGoingShift } from "../../helpers/apiCall";

const { TextArea } = Input;
// const iceStates = {
//   0: null,
//   1: <Ice1 height={65} />,
//   2: <Ice2 height={75} />,
// };

function ClockOutActive({
  time,
  editedTime,
  apiData,
  customTime,
  autoSuggestion,
  onCustomEndTime,
  setCustomTime,
  notes,
  whiteListError,
  onClockOut,
  onShiftNote,
  setLoadingColor,
  loadShiftData,
  resetValues,
  setNewShift,
  shiftConfiguration,
}) {
  const [clockOutVisible, setClockOutVisible] = useState(false);
  const [barWidth, setBarWidth] = useState(100);
  const [barStart, setBarStart] = useState(false);
  // const [startTime, setStartTime] = useState(
  //   apiData[apiData.length - 1]?.clockInDate
  // );
  const [lastShift, setLastShift] = useState(
    () => getLastOnGoingShift(apiData) || apiData[apiData.length - 1] || null
  );
  const [loading, setLoading] = useState(false);
  // const [iceState, setIceState] = useState(2);
  const auth = useAuth();
  const { programFields } = useSelector((state) => state.programFields);
  const teamTimezone = resolveClockingTimezone(
    lastShift,
    auth?.employee?.employeeTeam,
    programFields
  );

  const ipBlockMessage = whiteListError
    ? whiteListError +
      " Ju lutemi kontaktoni menaxherin tuaj për të mbyllur turnin."
    : null;

  const overnightBanner = useMemo(
    () =>
      lastShift?.clockOutDate == null
        ? overnightBannerCopy(lastShift, undefined, teamTimezone)
        : null,
    [lastShift, teamTimezone]
  );

  const handleClockOut = () => {
    if (ipBlockMessage) {
      showErrorMsg({ content: ipBlockMessage });
      return;
    }
    eventTracker("Clock Out", "click", "Opened clockout modal");
    setClockOutVisible(true);
  };

  useEffect(() => {
    setLastShift(
      getLastOnGoingShift(apiData) || apiData[apiData.length - 1] || null
    );
  }, [apiData]);

  useEffect(() => {
    let interval;
    if (!loading && barStart) {
      interval = setInterval(() => {
        setBarWidth((prev) => prev - 0.25);
      }, 10);
    }
    if (barWidth < 1) {
      setNewShift(true);
      setBarStart(false);
    }
    return () => {
      clearInterval(interval);
    };
  }, [loading, barWidth, barStart]);

  return (
    <>
      {loading === true ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "250px",
          }}
        >
          <HollowDotsSpinner color={"red"} size={24} />
        </div>
      ) : (
        <div
          className={`clock-out-active ${
            overnightBanner ? "clock-out-active--forgot" : ""
          }`}
        >
          {!overnightBanner ? <div className="time-indicator" /> : null}
          {!(!lastShift?.clockOutDate && loading === false) && (
            <ConfirmIcon style={{ marginBottom: "10px" }} />
          )}
          {!lastShift?.clockOutDate &&
            loading === false &&
            !overnightBanner && (
              <div
                className="clock-in-info"
                style={{
                  justifyContent: "center",
                }}
              >
                Turni ka filluar në orën
                <strong>
                  {dayjsTZ(lastShift?.clockInDate).format("HH:mm")}!
                </strong>
              </div>
            )}
          {!lastShift?.clockOutDate && loading === false ? (
            <div
              className={`clock-out-action ${
                overnightBanner ? "clock-out-action--forgot" : ""
              }`}
            >
              {ipBlockMessage ? (
                <Alert
                  type="warning"
                  showIcon
                  className="clock-out-ip-alert"
                  message={ipBlockMessage}
                />
              ) : null}
              {overnightBanner ? (
                <div className="clock-forgot-panel" role="status">
                  <div className="clock-forgot-panel__title">
                    {overnightBanner.title}
                  </div>
                  <div className="clock-forgot-panel__summary">
                    {overnightBanner.summary}
                  </div>
                  <div className="clock-forgot-panel__hint">
                    {overnightBanner.hint}
                  </div>
                </div>
              ) : null}
              <div className="clock-out">
                <button
                  className={`clock-out-btn ${
                    overnightBanner ? "clock-out-btn--forgot" : ""
                  }`}
                  onClick={handleClockOut}
                  style={
                    ipBlockMessage
                      ? { opacity: 0.55, cursor: "not-allowed" }
                      : undefined
                  }
                >
                  {overnightBanner ? "Mbyll turnin e harruar" : "Mbaro Turnin"}
                </button>
              </div>
              <div className="clock-out-now">
                Ora Tani:{" "}
                <Clock
                  format={"HH:mm"}
                  ticking={true}
                  timezone={"Europe/Tirane"}
                />
              </div>
              {editedTime && (
                <span className="warning-clock-out-edited">
                  Orari i mbarimit të turnit është ndryshuar.
                </span>
              )}
              {!editedTime && !overnightBanner && <span>Punë të mbarë!</span>}

              {editedTime && (
                <div
                  className="justify-note-wrapper"
                  style={{ marginTop: "-5px" }}
                >
                  <TextArea
                    value={notes?.clockOutNote}
                    onChange={(e) => onShiftNote(e, "clockOutNote")}
                    classname="justify-note"
                    placeholder="Shkruaj një shënim këtu..."
                    autoSize={{ minRows: 2, maxRows: 2 }}
                  />
                </div>
              )}
            </div>
          ) : (
            <>
              <div className="clock-out-action-finish">
                <div className="clock-out-info">
                  {/* <ClockOutIcon className="clock-out-icon" /> */}
                  <span>
                    {" "}
                    Turni u mbyll në orën{" "}
                    <strong>
                      {/* {apiData[apiData.length - 1]?.clockOutDate !== null
                        ? dayjsTZ(
                            apiData[apiData.length - 1]?.clockOutDate
                          ).format("HH:mm")
                        : "--:--"} */}
                      {lastShift?.clockOutDate !== null
                        ? dayjsTZ(lastShift?.clockOutDate).format("HH:mm")
                        : "--:--"}
                      !
                    </strong>
                  </span>
                </div>
                <h1>
                  Mirupafshim!
                  {/* <HomeOutlined style={{ color: "#FCC94A" }} /> */}
                </h1>
              </div>
              <span className="clockoutBar" style={{ width: `${barWidth}%` }} />
            </>
          )}
        </div>
      )}
      <ClockOutModal
        {...{
          clockOutVisible,
          setClockOutVisible,
          lastShift,
          apiData,
          setLoading,
          setLoadingColor,
          loadShiftData,
          resetValues,
          setNewShift,
          setLastShift,
          setBarStart,
          shiftConfiguration,
        }}
      />
    </>
  );
}

export default ClockOutActive;
